<div class="user-survey-container">
  <h2>User Survey</h2>
  <div class="button-grid">
    <button *ngFor="let button of buttons" class="btn-primary" (click)="onButtonClick(button.caption)">
      {{ button.caption }}
    </button>
  </div>

  <div *ngIf="selectedSurvey" class="survey-section">
    <h3>{{ selectedSurvey.title }}</h3>
    <form [formGroup]="surveyForm" (ngSubmit)="submitSurvey()">
      <div *ngFor="let question of selectedSurvey.field_srh_survey_question_export">
        <p>{{ question.survey_question_title }}</p>
        <div [ngSwitch]="question.survey_poll_question_type">
          <div class="options" *ngSwitchCase="'Single Choice Question'">
            <label *ngFor="let option of question.response_options">
              <input type="radio" [formControlName]="question.id" [value]="option">
              {{ option }}
            </label>
          </div>
          <div class="options-checkbox" *ngSwitchCase="'Multiple Choice Question'">
            <label *ngFor="let option of question.response_options">
              <input type="checkbox" [value]="option" (change)="onCheckboxChange($event, question.id)">
              {{ option }}
            </label>
          </div>
          <div *ngSwitchCase="'Text Based Question'">
            <textarea [formControlName]="question.id" maxlength="500" rows="5" placeholder="Enter your answer..."></textarea>
          </div>
        </div>
      </div>
      <button type="submit" class="btn-success">Submit</button>
    </form>
  </div>
</div>
